import { render, staticRenderFns } from "./bought-license.vue?vue&type=template&id=25802d73&scoped=true"
import script from "./bought-license.vue?vue&type=script&lang=js"
export * from "./bought-license.vue?vue&type=script&lang=js"
import style0 from "./bought-license.vue?vue&type=style&index=0&id=25802d73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25802d73",
  null
  
)

export default component.exports